import { Identifier, randomUUID } from "../id";
export class PCustomParameterInstanceId extends Identifier {
    constructor() {
        super("PCustomParameterInstanceId", randomUUID());
    }
}
